import styled from 'styled-components';

export const Box = styled.div `
    width: 100%;
    border-radius: 16px;
    height: auto;
    background: #FFF;
    padding: 24px;
    @media (max-width: 600px) {
        padding: 16px;
    }
    .flex-column-container {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: row !important;
        align-items: flex-start;
        gap: 25px;
        height: auto;
        @media (max-width: 900px) {
            flex-direction: column;
        }
    }
    .row-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 15px;
    }
    .flex-title {
        gap: 12px;
     }
    .title {
        color: #121212;
        font-size: 16px;
        font-weight: 600;
        @media (max-width: 600px) {
            font-size: 15px;
        }
    } 
`